import { useFilingDetailStore } from '../stores/filingDetailStore' // Adjust this import path as needed
import { watch, onUnmounted } from 'vue'

export const editable = {
    mounted(el, binding, vnode) {
        const store = useFilingDetailStore()

        const updateVisibility = (isEditable) => {
            el.style.display = isEditable ? '' : 'none'
        }

        const stopWatch = watch(() => store.isFilingEditable, (newValue) => {
            updateVisibility(newValue)
        }, { immediate: true })

        // Store the stop function directly on the element
        el._stopEditableWatch = stopWatch

        // Use the vnode's component instance to set up cleanup
        if (vnode.component) {
            const originalUnmounted = vnode.component.unmounted
            vnode.component.unmounted = () => {
                stopWatch()
                if (originalUnmounted) {
                    originalUnmounted()
                }
            }
        }
    },
    unmounted(el) {
        // Clean up the watcher if it exists
        if (el._stopEditableWatch) {
            el._stopEditableWatch()
        }
    }
}